import React, { useEffect, useState } from "react";
import styles from "./Detail.module.css";
import { connect } from "react-redux";
import { Collapse, Spin } from "antd";
import { Page } from "../../../helbest";
import IconStar from "../../../assets/images/icons/star.png";
import MapOutput from "../../components/Map/MapOutput/MapOutput";
import { google_map } from "../../../base/env";
import Pin from "../../../assets/images/icons/location_rv.png";
import { API } from "../../../request/api";
import ServiceCenterMap from "./ServiceCenterMap/ServiceCenterMap";
import Header from "../Cart/Header/Header";
import { useParams } from "react-router-dom";

const { Panel } = Collapse;

const Detail = (props) => {
  const { Login } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);

    API.get
      .serviceCenters(id, parseInt(Login.city_id))
      .then((response) => {
        if (response.success) {
          setData(response.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const arr = data.sort((a, b) => {
    if (a.rate.value < b.rate.value) {
      return 1;
    } else if (b.rate.value < a.rate.value) {
      return -1;
    } else {
      return 0;
    }
  });

  return (
    <Page
      className="page-sc"
      back={true}
      title="لیست مراکز ارائه خدمات"
      address="/service-center/"
      showFooter
      customHeader={<Header url={"/service-center"} label={"HiG Centers"} />}
      mobileContainer
      headerFix
    >
      <div className="service-centers-list container">
        {loading && (
          <div className="text-center mt-5">
            <Spin size="large" className="red" />
          </div>
        )}
        {!loading && (
          <>
            {data.length === 0 ? (
              <h4 className="text-center   pt-3 gray-color-low">
                متاسفانه موردی یافت نشد.
              </h4>
            ) : (
              <Collapse
                className="sc-collapse"
                style={{ paddingTop: "16px" }}
                accordion
                bordered={false}
                expandIcon={() => <></>}
              >
                {arr.map((x, i) => (
                  <Panel
                    style={{
                      boxShadow: "0px 0px 6px 1px rgba(0, 0, 0, 0.1)",
                    }}
                    className={`animated fadeInUp ${styles.borderr}`}
                    header={
                      <div className="scl-content-item">
                        <div className="as-name" style={{ paddingTop: 4 }}>
                          <h6 style={{ color: "var(--hig-color-black-2)" }}>
                            {x.name}
                          </h6>
                          <div className="flex align-center">
                            {x.rate.count > 10 && (
                              <label className=" ">{`${x.rate.count} نفر`}</label>
                            )}
                            <span
                              style={{
                                backgroundColor: "var(--hig-color-primary)",
                              }}
                              className="scl-rate flex center-content"
                            >
                              {x.rate.count > 10 ? (
                                <>
                                  {x.rate.value}
                                  <img
                                    src={IconStar}
                                    className="mr-1 star-icon"
                                    alt="*"
                                  />
                                </>
                              ) : (
                                "new"
                              )}
                            </span>
                          </div>
                        </div>
                        <hr />
                        <p>{`Manager: ${x.user.full_name}`}</p>
                        <p>{`Address: ${x.address.city} ، ${x.address.region} ، ${x.address.address}`}</p>
                        <div className="scl-more">
                          <label className=" ">
                            <img
                              src={Pin}
                              className="master-pin-icon mr-1"
                              alt=" "
                            />
                            Location on Map
                          </label>
                        </div>
                      </div>
                    }
                    key={i}
                  >
                    <div className="sidebar-map map">
                      {google_map && (
                        // <Map
                        //   data={[
                        //     {
                        //       lat: x.address.latitude,
                        //       lng: x.address.longitude,
                        //     },
                        //   ]}
                        // />
                        <ServiceCenterMap
                          lat={x.address.latitude}
                          lng={x.address.longitude}
                        />
                      )}
                      {!google_map && (
                        <MapOutput
                          lat={x.address.latitude}
                          lng={x.address.longitude}
                        />
                      )}
                    </div>
                  </Panel>
                ))}
              </Collapse>
            )}
          </>
        )}
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login,
});

export default connect(mapStateToProps)(Detail);
